import {
  DeliveryTimeGetInput,
  DeliveryTimeListInput,
  IsDeliveryTimeDocument,
  IsDeliveryTimeQuery,
  ListDeliveryAvailabilityDocument,
  ListDeliveryAvailabilityQuery,
  ListDeliveryTimeDocument,
  ListDeliveryTimeQuery,
} from "@/generated/graphql";
import { generateApolloClient } from "../apolloClientUtil";

/**
 * 配送時間が存在するかチェックする
 * @param deliveryTimeInput DeliveryTimeGetInput
 * @returns 存在する場合：配送時間情報、存在しない場合：null
 */
export async function isDeliveryTime(
  deliveryTimeInput: DeliveryTimeGetInput
): Promise<
  | (
      | {
          __typename?: "DeliveryTimeResponse" | undefined;
        }
      | null
      | undefined
    )[]
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();
    const deliveryTime = await apolloClient.query<IsDeliveryTimeQuery>({
      query: IsDeliveryTimeDocument,
      variables: {
        input: deliveryTimeInput,
      },
      fetchPolicy: "no-cache",
    });
    return deliveryTime.data.isDeliveryTime;
  } catch (err: unknown) {
    console.error(err);

    if (err instanceof Error) {
      err.message = "配達数情報の取得に失敗しました。";
      throw err;
    } else {
      throw new Error("配達数情報の取得に失敗しました。（Unknown error）");
    }
  }
}

/**
 * 配送時間一覧を取得する
 * @param deliveryTimeListInput DeliveryTimeListInput
 * @returns 配送時間一覧
 */
export async function listDeliveryTime(
  deliveryTimeListInput: DeliveryTimeListInput
): Promise<
  | (
      | {
          __typename?: "DeliveryTimeResponse" | undefined;
          area_code: string;
          chain_code: string;
          shop_code: string;
          delivery_id: number;
          delivery_start_time: string;
          delivery_end_time: string;
          max_deliverable_unit?: number | null | undefined;
          delivery_cap_mon?: number | null | undefined;
          delivery_cap_tue?: number | null | undefined;
          delivery_cap_wed?: number | null | undefined;
          delivery_cap_thu?: number | null | undefined;
          delivery_cap_fri?: number | null | undefined;
          delivery_cap_sat?: number | null | undefined;
          delivery_cap_sun?: number | null | undefined;
          display_days_setting?: number | null | undefined;
        }
      | null
      | undefined
    )[]
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();
    const deliveryTime = await apolloClient.query<ListDeliveryTimeQuery>({
      query: ListDeliveryTimeDocument,
      variables: {
        input: deliveryTimeListInput,
      },
      fetchPolicy: "no-cache",
    });
    return deliveryTime.data.listDeliveryTime;
  } catch (err: unknown) {
    console.error(err);

    if (err instanceof Error) {
      err.message = "配達数情報の取得に失敗しました。";
      throw err;
    } else {
      throw new Error("配達数情報の取得に失敗しました。（Unknown error）");
    }
  }
}

/**
 * 登録されている配送日(残数)一覧情報を取得する
 * @param customerCode カスタマーコード
 * @param chainCode チェーンコード
 * @param shopCode 店舗コード
 * @param areaCode エリアコード
 * @returns 登録されている配送日(残数)一覧情報
 */
export async function listDeliveryArailability(
  customerCode: string,
  chainCode: string,
  shopCode: string,
  areaCode: string
): Promise<
  | (
      | {
          __typename?: "DeliveryAvailability" | undefined;
          area_code: string;
          area_name: string;
          availability: string;
          chain_code: string;
          customer_code: string;
          delivery_date: string;
          delivery_id: number;
          delivery_id_desc: string;
          shop_code: string;
        }
      | null
      | undefined
    )[]
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();
    const listDelivery =
      await apolloClient.query<ListDeliveryAvailabilityQuery>({
        query: ListDeliveryAvailabilityDocument,
        variables: {
          customer_code: customerCode,
          chain_code: chainCode,
          shop_code: shopCode,
          area_code: areaCode,
        },
        fetchPolicy: "no-cache",
      });
    return listDelivery.data.listDeliveryAvailability;
  } catch (err: unknown) {
    console.error(err);

    if (err instanceof Error) {
      err.message = "配達数情報の取得に失敗しました。";
      throw err;
    } else {
      throw new Error("配達数情報の取得に失敗しました。（Unknown error）");
    }
  }
}
